import React from 'react';

const Date = ({ date, className }) => {
  const dateFormatted = typeof date === 'object' && date.format('DD / MM / YYYY');

  return !dateFormatted ? null : (
    <div data-testid="conversation-date" className={className}>
      {date.format('DD / MM / YYYY')}
    </div>
  );
};

export default Date;
